import React from 'react';

import './assets/css/global.css';
import './assets/css/bootstrap.css';
import './assets/css/figma.css';

import Routes from './routes';

function App() {
  return (
    <Routes />
  );
}

export default App;